/**
 * Project: fuse-react-app
 * FilePath: /src/client/app/MainToolbar.js
 * File: MainToolbar.js
 * Created Date: Tuesday, November 27th 2018, 7:48:40 pm
 * Author: Craig Bojko (craig.bojko@anexsys.com)
 * -----
 * Last Modified: Mon Feb 18 2019
 * Modified By: Craig Bojko
 * -----
 * Copyright (c) 2019 Anexsys
 * ------------------------------------
 */

import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import withReducer from 'modules/@fuse/store/withReducer'

import jspath from 'jspath'

import classNames from 'classnames'
import { Typography } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles/index'

import * as quickPanelActions from 'client/app/quickPanel/store/actions'
import reducer from 'client/app/store/reducers'

const styles = theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    width: '100%'
  },
  seperator: {
    width: 1,
    height: 64,
    backgroundColor: theme.palette.divider
  }
})

class MainToolbar extends Component {
  render () {
    const { classes, title } = this.props

    return (
      <div className={classNames(classes.root, 'flex flex-row')}>
        <div className='flex flex-1 px-24'>
          <Typography>
            <b>
              <span dangerouslySetInnerHTML={{ __html: title }} />
            </b>
          </Typography>
        </div>
      </div>
    )
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    toggleQuickPanel: quickPanelActions.toggleQuickPanel
  }, dispatch)
}

function mapStateToProps ({ globalAppData }) {
  return {
    title: jspath('.shared.title[0]', globalAppData)
  }
}

export default
withReducer('globalAppData', reducer)(
  withStyles(styles, { withTheme: true })(
    connect(mapStateToProps, mapDispatchToProps)(MainToolbar)
  )
)
